import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_IpgTransactionSkelton = _resolveComponent("IpgTransactionSkelton")!
  const _component_GatewaysTableComponent = _resolveComponent("GatewaysTableComponent")!
  const _component_CustomPaginationComponent = _resolveComponent("CustomPaginationComponent")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "users-list pa-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        flat: "",
        class: "mb-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            justify: "space-between"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button, index) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: index,
                  cols: "12",
                  sm: "4",
                  class: "pa-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      block: "",
                      large: "",
                      rounded: "",
                      color: button.value === _ctx.activeFilterButton ? 'primary' : 'grey lighten-4',
                      class: _normalizeClass([button.value === _ctx.activeFilterButton ? 'white--text' : 'grey--text text--darken-2', "text-capitalize"]),
                      elevation: "0",
                      onClick: ($event: any) => (_ctx.setFilterOfGatewayList(button.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(button.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["color", "class", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.getLoadingPanel)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            flat: "",
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
                        return _createVNode(_component_IpgTransactionSkelton, { key: index })
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            flat: "",
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_GatewaysTableComponent, { gateways: _ctx.getGateways }, null, 8, ["gateways"]),
              (Number(_ctx.getGlobalPagination.total) > Number(_ctx.getGlobalPagination.limit))
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    justify: "center",
                    class: "mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "8",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CustomPaginationComponent, {
                            "total-items": _ctx.getGlobalPagination.total,
                            "items-per-page": 50,
                            onPageChange: _ctx.handelPagination
                          }, null, 8, ["total-items", "onPageChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}